/// <amd-module name="VSS/Features/Markdown/Services/HtmlNormalizerService" />
import { Services, VssService } from "VSS/Platform/Context";

import { IHtmlNormalizerService } from "VSS/Features/Markdown/Interfaces/IHtmlNormalizerService";
import { HtmlNormalizer } from "VSS/Features/Markdown/Utils/HtmlNormalizer";

export class HtmlNormalizerService extends VssService implements IHtmlNormalizerService {
    /**
     * Normalizes the given html by removing the attributes like script and fixing incomplete tags.
     * Also allows the caller to specify additional attributes to remove, like 'class'
     *
     * @param html Html to normalize
     * @param additionalInvalidAttributes Additional attributes to remove
     * @param additionalValidAttributes Additional attributes to keep
     * @param additionalInvalidStyles Additional styles to remove
     * @param additionalValidStyles Additional styles to keep
     * @param encodeUnknownText
     * @param additionalInvalidProtocols Specify what link protocols to block (eg data to stop embedded images that may contain malicious content)
     * @return {string}
     */
    public normalizeStripAttributes(
        html: string,
        additionalInvalidAttributes?: string[],
        additionalValidAttributes?: string[],
        additionalInvalidStyles?: string[],
        additionalValidStyles?: string[],
        encodeUnknownText?: boolean,
        additionalInvalidProtocols?: string[]
    ): string {
        return HtmlNormalizer.normalizeStripAttributes(
            html,
            additionalInvalidAttributes,
            additionalValidAttributes,
            additionalInvalidStyles,
            additionalValidStyles,
            encodeUnknownText,
            additionalInvalidProtocols
        );
    }
}

Services.add("IHtmlNormalizerService", { serviceFactory: HtmlNormalizerService });
